import React, { Component } from 'react'

// eslint-disable-next-line import/no-named-as-default
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { ContainerAnchor, PortraitView, LandscapeView } from './styled'
import NavigationPortrait from './NavigationPortrait'
import NavigationLandscape from './NavigationLandscape'
import mockNavigation from '../../../utils/mocks/mockNavigation'

// COVID BANNER
import Ribbon from '../Ribbon/Ribbon'

const isBrowser = typeof window !== `undefined`

// TODO: We should avoid prop drilling, time to add context
class Navigation extends Component {
  constructor(props) {
    super(props)
    // TODO: After replacing all v1 pages with v2 we should not use mocks
    const { links } = mockNavigation

    this.state = {
      links,
      isNavOpen: false,
      isLinksHidden: false,
      isVisible: props.forceShowNav || false,
      maxWidth: props.maxWidth || '',
      isVersionTwo: props.isVersionTwo || false,
    }
  }

  componentDidMount() {
    const { isVisible } = this.state
    const { isLinksHidden } = this.props

    if (isLinksHidden) {
      this.setState({ links: [] })
    }

    if (isVisible) {
      return
    }

    if (!get(window, 'document')) {
      return
    }

    if (document.readyState === 'complete') {
      this.setState({ isVisible: true })
    } else {
      const intervalId = setInterval(this.timer, 1000)
      // store intervalId in the state so it can be accessed later:
      this.setState({ intervalId })
    }
  }

  componentWillUnmount() {
    const { intervalId } = this.state
    clearInterval(intervalId)
  }

  timer = () => {
    const { isVisible } = this.state

    if (isVisible) {
      return
    }

    if (get(document, 'readyState') === 'complete') {
      this.setState({ isVisible: true })
    }
  }

  handleOnClick = title => {
    this.setState(prevState => {
      const selectedLink = prevState.links.find(l => l.title === title)
      selectedLink.isOpen = !selectedLink.isOpen

      return {
        ...prevState,
        selectedLink,
      }
    })
  }

  handleToggleNav = () => {
    this.setState(prevState => ({
      ...prevState,
      isNavOpen: !prevState.isNavOpen,
    }))
  }

  render() {
    const { links, isNavOpen, isVisible, maxWidth, isVersionTwo } = this.state
    const { isLinksHidden, primaryCTAUrl } = this.props

    if (!isVisible) {
      return null
    }

    const getStartedUrl = primaryCTAUrl || 'https://signup.yoco.co.za/'

    return (
      <ContainerAnchor id="js-global-nav">
        {!isVersionTwo && !isLinksHidden && (
          <Ribbon
            // isSticky
            isInverse
            isBlue
            handleOnClick={() => {
              if (isBrowser) {
                window.location.href =
                  'https://www.yoco.co.za/blog/covid-19-small-business-guide/'
              }

              return false
            }}
          >
            <p>
              <a href="#">COVID-19 and your business</a>
            </p>
          </Ribbon>
        )}

        <PortraitView>
          <NavigationPortrait
            links={links}
            onDropDownAction={this.handleOnClick}
            onCloseAction={this.handleToggleNav}
            onMenuAction={this.handleToggleNav}
            isNavOpen={isNavOpen}
            isLoginButtonVisible={!isLinksHidden}
            getStartedUrl={getStartedUrl}
          />
        </PortraitView>

        <LandscapeView>
          <NavigationLandscape
            maxWidth={maxWidth}
            isVersionTwo={isVersionTwo}
            links={links}
            isLoginButtonVisible={!isLinksHidden}
            getStartedUrl={getStartedUrl}
          />
        </LandscapeView>
      </ContainerAnchor>
    )
  }
}

Navigation.propTypes = {
  // TODO: When we depreciate v1 we will pass in links as props from storyblok
  // links: PropTypes.arrayOf(TypeLink),
  forceShowNav: PropTypes.bool,
  maxWidth: PropTypes.string,
  isVersionTwo: PropTypes.bool,
  isLinksHidden: PropTypes.bool,
  primaryCTAUrl: PropTypes.string,
}

export default Navigation



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Navigation/Navigation.js